export const FATransferDocument = `FATransferDocument`;